// Imports React
import React, { useContext, useEffect, useState } from "react";
import Select, { components } from 'react-select';
// Import Context
import { AuthContext } from "../../../../contexts/AuthContext";
import staticData from '../../../../contexts/staticData.json';
// Import Icon
import addPME from '../../../../assets/icons/pmeWhite.svg';
import downArrow from '../../../../assets/icons/downArrow.svg';

function ContainerSearchPMEReport({ dataSearch, setDataSearch, handleSelect, handleButtonClick, dataProjects, establishmentList }) {
    const { userData } = useContext(AuthContext);
    const [filteredEstablishment, setFilteredEstablishment] = useState([]);

    useEffect(() => {
        if (userData?.permissions === 'admin' && dataSearch.holder && dataSearch.holder.id) {
            setFilteredEstablishment(establishmentList?.filter((establishment) => 
                establishment.projectId === dataSearch.holder.id
            ));
        }
    }, [userData, dataSearch, establishmentList]);

    const isButtonDisabled = !dataSearch.holder?.id;
    const regionData = staticData.regiones.find((region) => region.name === dataSearch?.region);
    const holders = dataProjects?.filter((project) => project.commune === dataSearch?.commune);

    // Cambiamos esta condición
    if (userData?.permissions !== 'admin') {
        return null;
    }

    return (
        <article className='container-search flex'>
            <div className='first-box flex'>
                <article className='box-input flex'>
                    <label htmlFor='region' className='hidden-label'>Región</label>
                    <Select
                        name='region'
                        id='region'
                        options={staticData.regiones.map((region) => ({
                            value: region.name,
                            label: region.name
                        }))}
                        onChange={handleSelect}
                        value={dataSearch.region ? { value: dataSearch.region, label: dataSearch.region } : null}
                        placeholder='Seleccionar Region'
                        className='select-custom'
                        classNamePrefix='select-custom'
                        components={{ DropdownIndicator }}
                    />
                </article>
                <article className='box-input flex'>
                    <label htmlFor='commune' className='hidden-label'>Comuna</label>
                    <Select
                        name='commune'
                        id='commune'
                        options={regionData?.communes.map((commune) => ({
                            value: commune.name,
                            label: commune.name
                        })).sort((a, b) => a.label.localeCompare(b.label))}
                        onChange={handleSelect}
                        value={dataSearch.commune ? { value: dataSearch.commune, label: dataSearch.commune } : null}
                        placeholder='Seleccionar Comuna'
                        className='select-custom'
                        classNamePrefix='select-custom'
                        components={{ DropdownIndicator }}
                        isDisabled={!dataSearch.region}
                    />
                </article>
            </div>
            <div className='second-box flex'>
                <article className='box-input flex'>
                    <label htmlFor='holder' className='hidden-label'>Sostenedor</label>
                    <Select
                        name='holder'
                        id='holder'
                        options={holders.map((holder) => ({
                            value: holder.nameProject,
                            label: holder.nameProject,
                            id: holder.id
                        }))}
                        onChange={handleSelect}
                        value={dataSearch.holder && dataSearch.holder.value ? 
                            { value: dataSearch.holder.value, label: dataSearch.holder.value } 
                            : null}
                        placeholder='Seleccionar Sostenedor'
                        className='select-custom'
                        classNamePrefix='select-custom'
                        components={{ DropdownIndicator }}
                        isDisabled={!dataSearch.commune}
                    />
                </article>
                <button 
                    type='button' 
                    className={`box-button active flex ${isButtonDisabled ? 'disabled' : ''}`} 
                    onClick={handleButtonClick} 
                    disabled={isButtonDisabled}
                >
                    <p>Buscar PME</p>
                    <img src={addPME} className='icon' alt='Icono para buscar pme' />
                </button>
            </div>
        </article>
    );
}

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={downArrow} alt="CustomArrow" />
        </components.DropdownIndicator>
    );
};

export default ContainerSearchPMEReport;